import { Box, Typography } from '@mui/material';
import { useStyles } from '../styles';
import { DayPartEnum, getDayPartedSlots, sortTimeSlots } from '../helpers';
import { MapTimeSlots } from './map-slots.component';
import { OnSetSelectedSlotType, Timeslot } from '../types';
import { EmptySlots, EmptySlotsProps } from './empty-slots.component';
import { useMemo } from 'react';

export type TimeslotsProps = {
  slots: Timeslot[];
  dayParting?: boolean;
  onSetSelectedSlot: OnSetSelectedSlotType;
} & EmptySlotsProps;

export const Timeslots: React.FC<TimeslotsProps> = props => {
  const { classes } = useStyles();

  const slots = useMemo(() => sortTimeSlots(props.slots), [ props.slots ]);

  if (!slots.length) {
    return  (
      <Box className={classes.timeSlotsRoot}>
        <EmptySlots {...props} />
      </Box>
    );

  }

  if (props.dayParting) {
    const dayPartedSlots = getDayPartedSlots(props.slots);

    return (
      <Box className={classes.timeSlotsRoot}>
        {Object.keys(dayPartedSlots).map((dayPart) => {
          const slots = dayPartedSlots[dayPart as DayPartEnum];

          return (
            <Box key={dayPart}>
              <Box pl={1} mb={1}>
                <Typography className={classes.fontWeight500}>{dayPart}</Typography>
              </Box>
              <MapTimeSlots slots={slots} onSetSelectedSlot={props.onSetSelectedSlot} />
            </Box>
          );
        })}
      </Box>
    );
  }

  return (
    <Box className={classes.timeSlotsRoot}>
      <MapTimeSlots slots={slots} onSetSelectedSlot={props.onSetSelectedSlot} />
    </Box>
  );
};
